// extracted by mini-css-extract-plugin
module.exports = {"closed":"Menu-module--closed--1mxz4","opened":"Menu-module--opened--3BRse"};